<template>
    <span class="text_error" v-html="validator.errors[0]"></span>
</template>

<script>
export default {
    props:['validator']
}
</script>
